import { api } from './api'

export interface HotmartClaimView {
  valid: boolean
  expiresAt?: string
  email?: string
  buyerName?: string | null
  subscriptionStatus?: string
  subscriptionPlanId?: string
  hasExistingUser?: boolean
  consumedAt?: string | null
}

export interface HotmartClaimCompleteResponse {
  token: string
  csrfToken: string
  user: {
    id: string
    email: string
    name: string
    role: string
    locale: string
  }
  tenant: {
    id: string
    name: string
    slug: string
    planId: string
  }
  hotmartSubscriptionId: string
}

class HotmartApi {
  async resendClaim(email: string) {
    return api['request']<{ ok: true; message: string }>('/api/integrations/hotmart/claims/resend', {
      method: 'POST',
      body: JSON.stringify({ email }),
    })
  }

  async getClaim(token: string) {
    return api['request']<HotmartClaimView>(`/api/integrations/hotmart/claims/${encodeURIComponent(token)}`, {
      method: 'GET',
    })
  }

  async completeClaim(token: string, payload: {
    name?: string
    businessName?: string
    password?: string
    locale?: string
    currency?: string
  }) {
    return api['request']<HotmartClaimCompleteResponse>(`/api/integrations/hotmart/claims/${encodeURIComponent(token)}/complete`, {
      method: 'POST',
      body: JSON.stringify(payload),
    })
  }
}

export const hotmartApi = new HotmartApi()
